import LImg from './src/main'

LImg.install = function(Vue) {
  Vue.component(LImg.name, LImg)
}

export default LImg
